import PerfectScrollbar from "perfect-scrollbar";
import { useEffect } from "react";

/**
 * Custom React hook to initialize and manage PerfectScrollbar on a specified element.
 *
 * This hook applies the PerfectScrollbar library to a referenced DOM element,
 * enabling enhanced scrollbar styling and behavior. It ensures that the scrollbar
 * is properly initialized when the component mounts and cleaned up when the component unmounts.
 *
 * @param {React.RefObject<HTMLElement>} ref - A React ref object pointing to the DOM element
 * where PerfectScrollbar should be applied.
 *
 *
 */
const usePerfectScrollabar = (ref) => {
  useEffect(() => {
    if (ref.current) {
      const ps = new PerfectScrollbar(ref.current, {
        wheelPropagation: true,
      });
      return () => {
        ps.destroy();
      };
    }
  }, [ref]);
};

export default usePerfectScrollabar;
